// @flow

import React, { useEffect, useState } from 'react'

import './FilterBy.css'
import arrow from '../Icons/icon-arrowdown-gray.svg'

import AppProfileFilter from './AppProfileFilter'
import GroupFilter from './GroupFilter'
import AppTypeFilter from './AppTypeFilter'
import AdminTypeFilter from './AdminTypeFilter'
// import DeviceTypeFilter from './DeviceTypeFilter'
import SourceTypeFilter from './SourceTypeFilter'
import { useDispatch, useSelector } from 'react-redux'
import { fetchProfiles, fetchGroups } from '../../Redux/Actions/FilterLists'

type Props = {
  changeFilter: Function,
  currentFilter: Function,
  type: string,
  showProfiles: boolean,
  showGroups: boolean
}

function FilterBy ({ changeFilter, currentFilter, type, showProfiles, showGroups }: Props) {
  const dispatch = useDispatch()

  const [expanded, setExpanded] = useState(false)

  const accountId = useSelector(state => state.account.ID)
  const profiles = useSelector(state => state.filterSources.profiles)
  const groups = useSelector(state => state.filterSources.groups)

  const useFetchDataEffect = (fun) => useEffect(fun, [])
  const useChangeFilterEffect = (fun) => useEffect(fun, [profiles, groups])

  const fetchDataEffect = () => {
    if (profiles.length < 1 || profiles[0]._id === '0') {
      dispatch(fetchProfiles(accountId, {}))
      dispatch(fetchGroups(accountId, {}))
    }
  }
  useFetchDataEffect(fetchDataEffect)

  const changeFilterEffect = () => {
    changeFilter(Object.assign({}, currentFilter, {}))
  }
  useChangeFilterEffect(changeFilterEffect)

  const toggle = () => {
    setExpanded(!expanded)
  }

  return (
    <div className='FilterBy'>
      {!expanded && (
        <div className='Header' onClick={toggle} style={{ cursor: 'pointer' }}>
          Show filter options <img className='arrow-direction' src={arrow} alt='expand' />
        </div>
      )}

      {expanded && (
        <div className='expanded'>
          <img className='arrow-direction' src={arrow} alt='expand' onClick={toggle} />
        </div>
      )}

      {expanded && profiles.length > 0 && showProfiles && (
        <AppProfileFilter changeFilter={changeFilter} currentFilter={currentFilter} profiles={profiles} />
      )}

      {expanded && showGroups && (
        <GroupFilter changeFilter={changeFilter} currentFilter={currentFilter} profiles={profiles} groups={groups} />
      )}

      {(expanded && type === 'App') && (
        <AppTypeFilter changeFilter={changeFilter} currentFilter={currentFilter} />
      )}

      {(expanded && type === 'Admin') && (
        <AdminTypeFilter changeFilter={changeFilter} currentFilter={currentFilter} />
      )}

      {(expanded && type === 'Device') && (
        <div></div>
        /* <DeviceTypeFilter changeFilter={changeFilter} currentFilter={currentFilter} /> */
      )}

      {(expanded && type === 'Source') && (
        <SourceTypeFilter changeFilter={changeFilter} currentFilter={currentFilter} />
      )}
    </div>
  )
}

export default FilterBy
